import { FunctionComponent } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './_reset.scss';

import './App.scss';
import { LayoutSection } from './core/Layout';
import { NotificationsContainer } from './core/Notifications/components/NotificationsContainer';
import { useAuthCallbackHandler } from './core/Security';
import { getBaseName } from './environment/EnvironmentStatic';
import { ThemeProvider } from "@volvo/vcdk-react";
import { selectThemeId } from './core/Layout/store/NavigationBarSlice';
import { useAppSelector } from './store/Hooks';

export const App: FunctionComponent = () => {
  const themeId = useAppSelector(selectThemeId);
  useAuthCallbackHandler();

  return (
    <BrowserRouter basename={getBaseName()}>
      <ThemeProvider themeId={themeId}>
        <LayoutSection />
        <NotificationsContainer />
      </ThemeProvider>
    </BrowserRouter>
  );
};
